export default __webpack_public_path__ + "static/media/nei.be9aa9bd.svg";